import { ProfileName, toLocationProfileType } from '@constants/integrations';

const facebookProfileUrlPattern = /^(https?:\/\/)?([\w-]+\.)*facebook\.com\/profile\.php(\?|$)/i;
const facebookProfileIdPattern = /[?&]id=[^&#]/i;
const uberEatsStoreUrlPattern = /^https?:\/\/([\w-]+\.)*ubereats\.com\/(?:[\w-]+\/)?store\/[^/?#]+\/[^/?#]+/i;
const bbbProfileUrlPattern =
    /^https?:\/\/([\w-]+\.)*bbb\.org\/[^/?#]+\/[^/?#]+\/[^/?#]+\/profile\/[^/?#]+\/[^/?#]+-\d{4}-\d+([/?#]|$)/i;
const bookingHotelUrlPattern = /^https?:\/\/([\w-]+\.)*booking\.com\/hotel\/[^/?#]+\/[^/?#]+\.html([?#]|$)/i;
const expediaGroupPropertyUrlPatterns = [
    /^https?:\/\/([\w-]+\.)*expedia\.[a-z]{2,3}(\.[a-z]{2})?\/([^?#]*[/.])?h\d+\.[a-z]+(-[a-z]+)*([/?#]|$)/i,
    /^https?:\/\/([\w-]+\.)*(hotels|hoteis|hoteles)\.com\/([^?#]*\/)?ho\d+(-tr)?([/?#]|$)/i,
];

export function validateUrl(url, type) {
    const validUrls = {
        2: ['facebook.'],
        1: ['yelp.'],
        8: ['trustpilot'],
        9: ['tripadvisor'],
        12: ['instagram.com/'],
        14: ['thefork'],
        15: ['deliveroo'],
        16: ['booking'],
        24: ['youtube'],
        25: ['x.com', 'twitter'],
        26: ['linkedin'],
        27: ['pinterest'],
        28: ['tiktok'],
        32: ['healthgrades.com'],
        33: ['zocdoc.com'],
        34: ['ratemds.com'],
        37: ['ubereats.com'],
        38: ['bbb.org'],
    };
    const r = /^https?:\/\/[^ "]+$/;
    const numericType = Number(type);
    const isValidTypeUrl = () => {
        if (toLocationProfileType(numericType) === ProfileName.Expedia) {
            return expediaGroupPropertyUrlPatterns.some(pattern => pattern.test(url));
        }

        let isValid = false;
        validUrls[numericType].forEach(subUrl => {
            if (url.includes(subUrl)) {
                isValid = true;
            }
        });

        // INFO: Facebook profile url without id is not valid
        if (numericType === 2 && facebookProfileUrlPattern.test(url) && !facebookProfileIdPattern.test(url)) {
            isValid = false;
        }

        if (numericType === 37 && !uberEatsStoreUrlPattern.test(url)) {
            isValid = false;
        }

        if (numericType === 38 && !bbbProfileUrlPattern.test(url)) {
            isValid = false;
        }

        if (numericType === 16 && !bookingHotelUrlPattern.test(url)) {
            isValid = false;
        }
        return isValid;
    };
    return r.test(url) && isValidTypeUrl();
}
